import { faqItemLocaleVisibilityFilter } from '@pkg/sanity-utils/faqItemLocaleVisibilityFilter';
import { translatedFieldQuery } from '@pkg/sanity-utils/translatedFieldQuery';
import groq from 'groq';
import { portableEditorFields } from '@pkg/portable-text-editor/web/portableEditor/groq';
import { portableTextWithReferences } from '@pkg/sanity-utils/portableTextWithReferences';

export const blockFaqBlockFields = groq`
  "items": coalesce(
    onetime.items[${faqItemLocaleVisibilityFilter}] {
    _key,
    analyticsProperty,
    question,
    answer[] {
        ${portableEditorFields},
        ${portableTextWithReferences}
      }
    },
    existing->items[${faqItemLocaleVisibilityFilter}] {
      _key,
      ${translatedFieldQuery('analyticsProperty')},
      ${translatedFieldQuery('question')},
      ${translatedFieldQuery('answer')}[] {
        ${portableEditorFields},
        ${portableTextWithReferences}
      }
    }
  )
`;
